export default __webpack_public_path__ + "static/media/dash.82dca2a3.png";